import {
  HelloProduct,
  IBackground,
  IProductConfigurations,
} from "../types/backend";

export const findBgSettings = (product: HelloProduct): IBackground => {
  const background: IBackground = {
    backgroundColor: undefined,
    gradientColor: undefined,
    fontColor: undefined,
    type:undefined,
    env_map:undefined,
    radius:120,
    height:12
  };
  if (product.rendering_rules?.background?.enabled) {
    background.backgroundColor = undefined;
    background.gradientColor = undefined;

    if (product.rendering_rules?.background?.backgroundColor?.length) {
      background.backgroundColor =
        product.rendering_rules.background.backgroundColor;
    }

    if (product.rendering_rules?.background?.gradientColor?.length) {
      background.gradientColor =
        product.rendering_rules.background.gradientColor;
    }

    if (product.rendering_rules?.background?.fontColor?.length) {
      background.fontColor = product.rendering_rules.background.fontColor;
    }

    if (product.rendering_rules?.background?.type?.length) {
      background.type = product.rendering_rules.background.type; 
    }

    if (product.rendering_rules?.background?.env_map?.length) {
      background.env_map =product.rendering_rules.background.env_map; 
    }

    if (product.rendering_rules?.background?.radius) {
      background.radius = product.rendering_rules.background.radius;
    }
    if (product.rendering_rules?.background?.height) {
      background.height = product.rendering_rules.background.height;
    }
  } else {
    if (typeof product.application !== "string") {
      if (product.application.sdk_settings?.background?.enabled) {
        if (
          product.application.sdk_settings?.background?.background_color?.length
        ) {
          background.backgroundColor =
            product.application.sdk_settings.background.background_color;
        }

        if (
          product.application.sdk_settings?.background?.gradient_color?.length
        ) {
          background.gradientColor =
            product.application.sdk_settings.background.gradient_color;
        }

        if (product.application.sdk_settings?.background?.font_color?.length) {
          background.fontColor =
            product.application.sdk_settings.background.font_color;
        }

        if (product.application.sdk_settings?.background?.bg_type?.length) {
          background.type =product.application.sdk_settings.background.bg_type; 
        }


        if (product.rendering_rules?.background?.env_map?.length) {
          background.env_map =  product.application.sdk_settings.background.env_map; 
        }
    
        if (product.rendering_rules?.background?.radius) {
          background.radius = product.application.sdk_settings.background.radius;
        }
        if (product.rendering_rules?.background?.height) {
          background.height = product.application.sdk_settings.background.height;
        }
      }
    }
  }
  return background;
};

export const findProductConfigurations = (product: HelloProduct) => {
  const configurations: IProductConfigurations = {
    customStyles: undefined,
  };
  product.configurations?.forEach((config) => {
    switch (config.key) {
      case "custom_css":
        const css = config.value;
        if (css && typeof css === "string" && css.length) {
          configurations.customStyles = css;
        }
    }
  });
  return configurations;
};
